import { FieldConfig } from './types';

const NUMERIC_PATTERN = /^([0-9]+)$/;
const STRING_PATTERN = /^(.+)$ /;

export const SEARCH_CONFIG: FieldConfig = {
  Validation: {
    'Application ID': [
      {
        name: 'applicationId',
        label: 'Application ID',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'Portfolio ID': [
      {
        name: 'portfolioId',
        label: 'Portfolio ID',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'CMHC Account Number': [
      {
        name: 'cmhcAccountNumber',
        label: 'CMHC Account Number',
        type: 'number',
        required: true,
        maxLength: 30,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'CMHC Low Ratio Account Number': [
      {
        name: 'lowRatioCmhcAccountNumber',
        label: 'CMHC Low Ratio Account Number',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'Lender Reference Number': [
      {
        name: 'lenderLoanNumber',
        label: 'Lender Reference Number',
        type: 'text',
        required: true,
        maxLength: 30,
        pattern: STRING_PATTERN,
        replaceAllSpace: true
      }
    ],
    Borrower: [
      {
        name: 'borrowerFirstName',
        label: 'First Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'borrowerLastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      }
    ],
    'Property Address': [
      {
        name: 'addressStreetNumber',
        label: 'Street Number',
        type: 'text',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressStreetName',
        label: 'Street Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressMunicipality',
        label: 'Municipality',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressPostalCode',
        label: 'Postal code',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      }
    ]
  },
  Pool: {
    'Master Pool Number': [
      {
        name: 'masterPoolCmhcAccountNumber',
        label: 'Master Pool Number',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'Sub Pool Number': [
      {
        name: 'poolCmhcAccountNumber',
        label: 'Sub Pool Number',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'CMHC Account Number': [
      {
        name: 'cmhcAccountNumber',
        label: 'CMHC Account Number',
        type: 'number',
        required: true,
        maxLength: 30,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'CMHC Low Ratio Account Number': [
      {
        name: 'lowRatioCmhcAccountNumber',
        label: 'CMHC Low Ratio Account Number',
        type: 'number',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: true
      }
    ],
    'Lender Reference Number': [
      {
        name: 'lenderLoanNumber',
        label: 'Lender Reference Number',
        type: 'text',
        required: true,
        maxLength: 30,
        pattern: STRING_PATTERN,
        replaceAllSpace: true
      }
    ],
    Borrower: [
      {
        name: 'borrowerFirstName',
        label: 'First Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'borrowerLastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      }
    ],
    'Property Address': [
      {
        name: 'addressStreetNumber',
        label: 'Street Number',
        type: 'text',
        required: true,
        pattern: NUMERIC_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressStreetName',
        label: 'Street Name',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressMunicipality',
        label: 'Municipality',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      },
      {
        name: 'addressPostalCode',
        label: 'Postal code',
        type: 'text',
        required: true,
        pattern: STRING_PATTERN,
        replaceAllSpace: false
      }
    ]
  }
};

export const QUERY_PARAMS = [
  'applicationId',
  'portfolioId',
  'cmhcAccountNumber',
  'lowRatioCmhcAccountNumber',
  'lenderLoanNumber',
  'borrowerFirstName',
  'borrowerLastName',
  'addressStreetNumber',
  'addressStreetName',
  'addressMunicipality',
  'addressPostalCode',
  'masterPoolCmhcAccountNumber',
  'poolCmhcAccountNumber'
];

export const DATA_TYPES_FOR_PARAMS = {
  'Portfolio ID': 'portfolioId',
  'Application ID': 'applicationId',
  'CMHC Account Number': 'cmhcAccountNumber',
  'CMHC Low Ratio Account Number': 'cmhcLowRatioAccountNumber',
  'Lender Reference Number': 'lenderReferenceNumber',
  Borrower: 'borrower',
  'Property Address': 'propertyAddress',
  'Master Pool Number': 'masterPoolCmhcAccountNumber',
  'Sub Pool Number': 'poolCmhcAccountNumber'
};
